/**
 * Created by lihanying on 2017/7/6.
 */
import { GETWORKERLIST } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETWORKERLIST:
      return Object.assign({}, state, { employeeList: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/reduce.js